import cronstrue from 'cronstrue';
import type { ServicesApiCopilotCron } from '@/services/api/services-api';

export function formatSchedule(schedule: string): string {
  try {
    return cronstrue.toString(schedule);
  } catch {
    return schedule;
  }
}

export function getRoutineStatus(routine: ServicesApiCopilotCron): {
  color: 'green' | 'grey' | 'red';
  label: string;
} {
  if (routine.last_status === 'error') return { color: 'red', label: 'Error' };
  if (routine.paused) return { color: 'grey', label: 'Paused' };
  return { color: 'green', label: 'Active' };
}
